module.exports = __webpack_public_path__ + "img/kort-21.e14739a1.png";